import { useQuery } from '@tanstack/react-query';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { InvestmentProgrammeDocumentDetailsRes } from '@dealstack/shared/lib/generated';
import { buildInvestmentProgrammeDocumentQueryKey } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/hooks/documentQueryKeys';

export const useInvestmentProgrammeDocument = (options: {
	dealId: string;
	programmeId: string;
	documentWorkflowInstanceId: string;
}) => {
	const { dealId, programmeId, documentWorkflowInstanceId } = options;

	const endpoint = formatUnicorn(
		API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_DOCUMENTWORKFLOWINSTANCEID_GET,
		{
			dealId,
			programmeId,
			documentWorkflowInstanceId,
		}
	);

	return useQuery({
		enabled: !!dealId && !!programmeId && !!documentWorkflowInstanceId,
		queryKey: buildInvestmentProgrammeDocumentQueryKey({
			dealId,
			programmeId,
			documentWorkflowInstanceId,
		}),
		queryFn: async () => {
			const response = await makeRequest<
				ApiV1.Response<InvestmentProgrammeDocumentDetailsRes>
			>({
				endpoint,
				method: HTTP_METHOD.GET,
			});
			return response;
		},
	});
};
